var MenuAboutType;
(function (MenuAboutType) {
    MenuAboutType["TYPE_INTERNAL_LINK"] = "internalLink";
    MenuAboutType["TYPE_EXTERNAL_LINK"] = "externalLink";
    MenuAboutType["TYPE_BUTTON"] = "button";
})(MenuAboutType || (MenuAboutType = {}));
/*
 push: allows a redirection to a push (merchandising, poster, etc.)
 story: allows a redirection to a story
 other: allows a free redirection (manually configured URL)
 grid: allows a redirection to a grid
 name: allows you to override the category name
 */
var MenuType;
(function (MenuType) {
    MenuType["TYPE_PUSH"] = "push";
    MenuType["TYPE_STORY"] = "story";
    MenuType["TYPE_OTHER"] = "other";
    MenuType["TYPE_GRID"] = "grid";
    MenuType["TYPE_NAME"] = "name";
})(MenuType || (MenuType = {}));

export { MenuAboutType, MenuType };
